import type { DocumentDeleteDropdownMenuItemFragment } from "../client/generated";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Icon } from "@mdi/react";
import { mdiTrashCan } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";
import { useState } from "react";
import { DocumentDeleteDialogContent } from "./DocumentDeleteDialogContent";

type Props = {
  fragment: DocumentDeleteDropdownMenuItemFragment;
};

export function DocumentDeleteDropdownMenuItem({ fragment }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger data-testid="document-delete-dropdown-menu-item" asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <Icon path={mdiTrashCan} size="1.25rem" />
          {t("DocumentDeleteDropdownMenuItem.label")}
        </DropdownMenuItem>
      </DialogTrigger>
      <DocumentDeleteDialogContent
        fragment={fragment}
        onDone={() => setIsOpen(false)}
      />
    </Dialog>
  );
}
